module.exports = __webpack_public_path__ + "img/FFRDCS.d8ee0723.svg";